import TabbedDataTable, { TabbedDataTableProps } from './TabbedDataTable'
import DataTablePro from './DataTablePro'

const TabbedDataTablePro = (props: TabbedDataTableProps) => (
  <TabbedDataTable {...props} TableComponent={DataTablePro} />
)

export default TabbedDataTablePro
